import { COMPLETELY_BANNED_COUNTRIES } from "@/lib/constants/config";
import type { PaymentPlugin } from "@/plugins/payment-plugin-registry";
import { free_payment_handler } from "./payment-handler";

export const free_plugin: PaymentPlugin = {
  id: "free", // Special payment method for zero-value orders
  country_rules: {
    banned_countries: COMPLETELY_BANNED_COUNTRIES,
  },
  process_payment: free_payment_handler,
  // No UI initialization needed for free payments
  async initialize_ui(): Promise<void> {
    // Free payments don't require any UI initialization
    return Promise.resolve();
  },
};
